import React, {Component} from "react";
import {I18n} from "aws-amplify";
import * as PropTypes from "prop-types";
import * as qs from "qs";
import Header from "./parts/Header";
import Footer from "./parts/Footer";
import RakutenLogin from "./parts/RakutenLogin";
import {GeneLifeDict} from "../translate/GeneLife";
import UAjudge from "../Components/UAComponent";
import '../Styles/genelife.css';
import '../Styles/subpages.css';
import '../Styles/login.css';
import '../Styles/wgs.css';
import BlockUi from "react-block-ui";
import AffiliateAgreementsComponent from "./parts/AffiliateAgreementsComponent";
import {SignUpModal} from "./parts/SignUpModla";
import {CvGeneticTesting, NormalGeneticTesting} from "./parts/LoginForm";

I18n.setLanguage('ja-JP');
I18n.putVocabularies(GeneLifeDict);

export class SignInComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
      changeForm: 'normal',
      normalChecked: false,
      cvGeneticChecked: false,
      signUpOpenModal: false,
      mode: ""
    };
    this.toggleShow = this.toggleShow.bind(this);
    this.handleLoginForm = this.handleLoginForm.bind(this);
    this.toggleOpenSignUpModal = this.toggleOpenSignUpModal.bind(this);
  }

  handlePasswordChange(e) {
    this.setState({password: e.target.value});
  }

  toggleShow() {
    this.setState({
      hidden: !this.state.hidden
    });
  }

  toggleOpenSignUpModal() {
    this.setState({
      signUpOpenModal: !this.state.signUpOpenModal
    });
  }

  handleLoginForm(e) {
    if (e.target.name === "normal_genetic_test") {
      this.setState({changeForm: "normal", normalChecked: true, cvGeneticChecked: false});
    } else if (e.target.name === "cv_genetic_test") {
      this.setState({changeForm: "cv", normalChecked: false, cvGeneticChecked: true});
    }
  }

  componentDidMount() {
    const params = qs.parse(window.location.search.substr(1));
    const mode = params["mode"];
    if (!this.state.mode && mode === "wgs") {
        this.setState({mode: "wgs"});
    }
    if (this.props.password) {
      this.setState({password: this.props.password});
    }
  }

  render() {
    let modal = <AffiliateAgreementsComponent show={this.props.openInput} onHide={this.props.handleClose} onClick={this.props.handleInputAffiliateChange} agreement1={this.props.agreement1} agreement2={this.props.agreement2} disabled={this.props.agreeBtnDisabled} onClick1={this.props.handleAffiliateRequest}/>

    let loginForm = this.state.changeForm === 'normal'
      ? (<NormalGeneticTesting mySignIn={this.props.mySignIn} hidden={this.state.hidden} onClick={this.toggleShow} onClick1={this.props.changeStateForgotPassFunc} onClick2={this.props.changeStateEccAcountChkInFunc} onClick3={this.props.signIn} disabled={this.props.loading}/>)
      : (<CvGeneticTesting/>);
    const signUpModal = this.state.signUpOpenModal
      ? <SignUpModal changeStateSignInFunc={this.props.changeStateSignInFunc} toggleOpenSignUpModal={this.toggleOpenSignUpModal} mode={this.state.mode}/>
      : null;
    return (<div>
      {signUpModal}
      <Header authState={this.props.authState}/>
      <div>
        {this.props.openInput && modal}
        <BlockUi tag="div" blocking={this.props.blocking} message="ログイン処理中です。しばらくお待ちください。" keepInView={this.props.keepInView}>
          <div className="covidmainfield -login">
            <div className="contentwrap">
              <div className="title-login">
                <h1 className="logintitle">ログイン</h1>
              </div>
              <div className="mainfieldrow">
                <div className="col-left">
                  <div className="fieldwrap loginbox">
                    <h2 className="fieldtitle">GeneLife会員の方 ログイン</h2>
                    <div className="inputtitle">検査キット種別の選択</div>
                    <ul className="list-typeselect">
                      <li className={this.state.normalChecked
                          ? '-select'
                          : ''}><input type="radio" name="normal_genetic_test" id="radio01" className="checktypeimg -radio" onChange={this.handleLoginForm} checked={this.state.normalChecked}/>
                        <label className="checktype -genetictest" htmlFor="radio01">遺伝子検査<br /><span>※GeneLife WGS含む</span></label>
                      </li>
                      <li className={this.state.cvGeneticChecked
                          ? '-select'
                          : ''}><input type="radio" name="cv_genetic_test" id="radio02" onChange={this.handleLoginForm} checked={this.state.cvGeneticChecked} className="checktypeimg -radio"/>
                        <label className="checktype -covidpcr" htmlFor="radio02">新型コロナウィルスPCR検査</label>
                      </li>
                    </ul>
                    <div  style={(this.state.normalChecked || this.state.cvGeneticChecked) ? {}: {display: "none"}}>
                    {loginForm}
                    </div>


                  </div>
                  {/* <RakutenLogin normalChecked={this.state.normalChecked}/> */}

                </div>

                <div className="col-right">
                  <div className="fieldwrap">
                    <h2 className="fieldtitle">はじめての方</h2>
                    <div className="buttonwrap">
                      <input type="button" name="" value="新規登録" className="button" onClick={this.toggleOpenSignUpModal}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <UAjudge></UAjudge>
          <Footer/>
        </BlockUi>

      </div>
    </div>)
  }
}

SignInComponent.propTypes = {
  theme: PropTypes.any,
  authState: PropTypes.string,
  mySignIn: PropTypes.any,
  changeStateForgotPassFunc: PropTypes.func,
  signIn: PropTypes.func,
  changeStateSignOutFunc: PropTypes.func,
  loading: PropTypes.any,
  openInput: PropTypes.bool,
  handleClose: PropTypes.func,
  handleAffiliateRequest: PropTypes.func,
  changeStateSignInFunc: PropTypes.func,
  changeStateEccAcountChkInFunc: PropTypes.func,
  handleInputAffiliateChange: PropTypes.func,
  agreement1: PropTypes.bool,
  agreement2: PropTypes.bool,
  agreeBtnDisabled: PropTypes.bool
};
